import Link from 'next/link';
import { useRouter } from 'next/router';

const ContentBlock = (): JSX.Element => {
  // ---->> temporary links section
  const router = useRouter();
  const { pathname, asPath, query } = router;

  const changeLang = (lang: string) => {
    router.push({ pathname, query }, asPath, { locale: lang });
  };
  // <<---- temporary links section

  return (
    <div>
      <div>Temporary development links section:</div>
      <ul className="*:border-beige-shade10 flex flex-wrap *:m-1 *:whitespace-nowrap *:rounded *:border *:px-0.5">
        <li>
          <button onClick={() => changeLang('en')}>En</button>
        </li>
        <li>
          <button onClick={() => changeLang('ja-JP')}>ja-JP</button>
        </li>
        <li>
          <button onClick={() => changeLang('pl-PL')}>pl</button>
        </li>
        <li>
          <Link href="/about">about</Link>
        </li>
        <li>
          <Link href="/about/design">design</Link>
        </li>
        <li>
          <Link href="/bluetooth-headsets/jabra-elite-4/buy">buy jabra elite 4 </Link>
        </li>
        <li>
          <Link href="/business/office-headsets/jabra-evolve/jabra-evolve2-85/buy">
            buy jabra evolve2 85
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default ContentBlock;
